import { FC } from "react"
import { Snackbar as MUISnackbar } from "@mui/material"
import "./index.scss"

export interface SnackBarProps {
   isOpen: boolean
   message: string
   duration?: number | null
   onClose?: () => void
}

const SnackBar: FC<SnackBarProps> = ({
   isOpen,
   message,
   duration = 3000,
   onClose = () => {},
}) => {
   return (
      <MUISnackbar
         className="snackbar"
         open={isOpen}
         message={message}
         autoHideDuration={duration}
         onClose={onClose}
         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
   )
}

export default SnackBar
